import React, { useCallback } from 'react'
import { generatePhrase } from 'tve/helpers/navigation_helper'

export const NavigationItem = ({ data, step, next }) => {
  const eventHandler = useCallback(
    (event) => {
      event.preventDefault()
      next(step)
    },
    [next, step]
  )

  const href = `#${step}`

  return (
    <li>
      <a href={href} onClick={eventHandler}>
        {generatePhrase(data, step)}
      </a>
    </li>
  )
}

NavigationItem.displayName = 'NavigationItem'
